var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{staticClass:"button-shadow-secondary",attrs:{"icon":""},on:{"click":_vm.back}},[_c('i',{staticClass:"bx bx-chevron-left"})])}
var staticRenderFns = []

export { render, staticRenderFns }